// src/components/probe/ProbeTimeline.tsx
import React from 'react';
import { LogRecord } from '../../models/Probe';
import { getSeverityColorClass } from '../../utils/severityUtils';

interface ProbeTimelineProps {
  events: LogRecord[];
  selectedEventIndex: number | null;
  onSelectEvent: (index: number) => void;
}

const ProbeTimeline: React.FC<ProbeTimelineProps> = ({ events, selectedEventIndex, onSelectEvent }) => {
  const getSeverityChar = (severity: string) => {
    return severity ? severity.charAt(0).toUpperCase() : '?';
  };

  return (
    <div className="p-4 border-b border-border-dark overflow-x-auto">
      <h3 className="text-lg font-semibold mb-3 text-text-light">Event Timeline</h3>
      <div className="flex-shrink-0 pt-4 pb-4 max-h-[200px] overflow-y-auto">
      {events.length === 0 ? (
        <p className="text-text-dark text-sm">No events found for this request ID.</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {events.map((event, index) => (
            <button
              key={index}
              onClick={() => onSelectEvent(index)} /*  rounded-full */
              className={`
                flex items-center justify-center w-5 h-5 rounded-full border-none text-sm font-bold transition-all duration-200
                ${getSeverityColorClass(event.severity as string)}
                ${selectedEventIndex === index ? 'ring-4 ring-offset-2 ring-accent-color ring-offset-background-dark transform scale-200' : 'hover:opacity-80'}
              `}
              title={`${event.severity || 'UNKNOWN'} - ${event.message || 'No message'}`}
            >
              {getSeverityChar(event.severity as string)}
            </button>
          ))}
        </div>
      )}
      </div>
    </div>
  );
};

export default ProbeTimeline;